<div class="container">
  <hyperkit-typography
    class="page-title"
    variant="h1"
    align="left"
    color="primary"
    >Environments</hyperkit-typography
  >

  <div class="environment-wrapper">
    @if (environments$ | async; as environments) {
      <div>
        <div class="add">
          @if (environments.length == 0) {
            <div>No environments to display.</div>
          }
          <hyperkit-button
            (click)="newEnvironment()"
            size="small"
            variant="standard"
            text="New Environment"
            color="tertiary"
          ></hyperkit-button>
        </div>
        @for (environment of environments$ | async; track environment) {
          <kendo-card width="100%" orientation="vertical">
            <div class="k-vstack">
              <kendo-card-header>
                <div class="k-hstack card-actions">
                  <hyperkit-typography
                    kendoCardTitle
                    variant="body"
                    size="lg"
                    align="left"
                    color="primary"
                    >{{ environment.name }}</hyperkit-typography
                  >
                  <div class="button-options">
                    <hyperkit-button
                      (click)="editEnvironment(environment)"
                      size="small"
                      variant="icon"
                      icon="edit"
                      color="secondary"
                    ></hyperkit-button>
                    <hyperkit-button
                      routerLink="{{ environment.id }}/tool"
                      size="small"
                      variant="icon"
                      icon="plus"
                      color="secondary"
                      >Add Tool</hyperkit-button
                    >
                    <hyperkit-button
                      (click)="deleteEnvironment(environment)"
                      size="small"
                      variant="icon"
                      icon="trash"
                      color="secondary"
                    ></hyperkit-button>
                  </div>
                </div>
                <hyperkit-typography
                  kendoCardSubtitle
                  variant="body"
                  size="lg"
                  align="left"
                  color="body"
                  >{{ environment.description }}</hyperkit-typography
                >
              </kendo-card-header>
              <kendo-card-body width="100%">
                <div class="unknown">
                  @for (tool of environment.tools; track tool) {
                    <div class="k-hstack">
                      <img
                        class="mr-3"
                        height="30px"
                        width="30px"
                        [src]="getToolIcon(tool.product)"
                      />
                      <div>
                        <hyperkit-link
                          routerLink="{{ environment.id }}/tool/{{ tool.id }}"
                          variant="body"
                          size="lg"
                          align="left"
                          color="primary"
                          text="{{ tool.name }}"
                        ></hyperkit-link>
                        <hyperkit-typography
                          variant="body"
                          size="lg"
                          align="left"
                          color="secondary"
                          >{{ tool.product }}</hyperkit-typography
                        >
                      </div>
                    </div>
                  }
                  @if (environment.tools.length == 0) {
                    <div>
                      <hyperkit-typography
                        variant="body"
                        size="sm"
                        align="left"
                        color="secondary"
                        >No tools to display.</hyperkit-typography
                      >
                    </div>
                  }
                </div>
              </kendo-card-body>
            </div>
          </kendo-card>
        }
      </div>
    } @else {
      <div class="loading">
        <kendo-loader type="pulsing" themeColor="primary" size="large">
        </kendo-loader>
      </div>
    }
  </div>
</div>
<router-outlet></router-outlet>
